// extracted by mini-css-extract-plugin
module.exports = {"containerhead":"actorDetail_containerhead__Tnghh","close-image":"actorDetail_close-image__1QoVj"};